import ServiceDetailsModal from './ServiceDetailsModal'

export default ServiceDetailsModal
